import * as React from 'react';
import { useEffect, useRef } from 'react';

import { InlineNotification } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

export const RestoreSuccessNotification = ({ onDismiss }: { onDismiss: () => void }) => {
  const notificationRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const dismissButton = notificationRef.current?.querySelector<HTMLButtonElement>('[aria-label="Dismiss"]');
    dismissButton?.focus();
  }, []);

  return (
    <InlineNotification
      severity="success"
      title={_t('This item has been restored to your main calendar')}
      onDismiss={onDismiss}
      ref={notificationRef}
      children=""
    />
  );
};
